import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsDialogModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';

import { CommitmentDetailsDialogComponent } from './commitment-details-dialog.component';
import { TranslationIdMap } from './commitment-details.i18n';
import { CommitmentDetailsDialogService } from './commitment-details.service';

@NgModule({
    declarations: [CommitmentDetailsDialogComponent],
    exports: [CommitmentDetailsDialogComponent],
    imports: [
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsTooltipModule,
        CommonModule,
    ],
    providers: [CommitmentDetailsDialogService],
})
export class CmpsWinningCommitmentsDialogModule {}
